// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NAXp","colBig":"styles_colBig__3iUHF","colSmall":"styles_colSmall__3nqu8","shopifyNameWrapper":"styles_shopifyNameWrapper__2lqpc"};